<template>
  <div
    class="action-footer flex s-a-center m-a-between"
    :class="{'active': selectedArtists.length > 0}"
  >
    <player></player>
    <div class="action-buttons">
      <button class="btn btn-secondary" @click="resetRecommendations">Reset recommendations</button>
      <button
        v-if="selectedArtists.length > 0"
        class="btn btn-primary"
        @click="fetchRecommendations"
      >Get recommendations</button>
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";
import player from "./Player";
export default {
  name: "actionFooter",
  components: { player },
  data: () => {
    return {
      selectedArtists: []
    };
  },
  methods: {
    handleEmit(emitData) {
      this.selectedArtists = emitData;
    },
    fetchRecommendations() {
      bus.$emit("fetchRecs", {
        selectedArtists: this.selectedArtists
      });
    },
    resetRecommendations() {
      this.selectedArtists = [];
      bus.$emit("resetRecs");
    }
  },
  created() {
    bus.$on("updateActionBar", this.handleEmit);
  }
};
</script>

<style scoped>
.action-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  width: 100%;
  background: #fff;
  border-top: 1px solid #444;
  opacity: 1;
  transition: transform 0.1s ease;
  padding: 1rem 10rem;
  box-sizing: border-box;
  transform: translateY(80px);
  z-index: 2;
}
.action-footer.active {
  transform: translateY(0);
}
.action-buttons .btn:first-child{
  margin-right: 1rem;
}
</style>